import { useMemo, useRef } from 'react';

export type ReopenGuard = {
  blocked: () => boolean;
  markClosed: () => void;
};

// Dismissing an overlay by clicking its own trigger fires the close and the trigger's click in the
// same gesture, which would reopen it. Swallow the click that lands in the same frame as the close.
export const useReopenGuard = (): ReopenGuard => {
  const justClosed = useRef(false);

  // Stable, so a caller can leave it out of a useCallback dependency list the way it left the ref out.
  return useMemo(
    () => ({
      blocked: () => justClosed.current,
      markClosed: () => {
        justClosed.current = true;
        requestAnimationFrame(() => {
          justClosed.current = false;
        });
      },
    }),
    []
  );
};
